export function toPreviewImages(imageList) {
  return (imageList || []).map((image) => {
    if (image?.file) {
      return {
        file: image.file,
        previewUrl: URL.createObjectURL(image.file)
      };
    }

    return { previewUrl: image?.previewUrl || image?.data_url || '' };
  });
}

export function revokePreviewImages(imageList) {
  (imageList || []).forEach((image) => {
    if (typeof image?.previewUrl === 'string' && image.previewUrl.startsWith('blob:')) {
      URL.revokeObjectURL(image.previewUrl);
    }
  });
}
